import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import api from '@/api';
import FileEdit from '../edit/index';
export default {
  name: 'FileList',
  components: {
    FileEdit: FileEdit
  },
  data: function data() {
    return {
      isSelect: this.checkauthority('select_file'),
      isCreate: this.checkauthority('select_add'),
      isUpdate: this.checkauthority('select_update'),
      isDelete: this.checkauthority('select_delete'),
      playTitle: '',
      dialogPlay: false,
      videoUrl: true,
      uploadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      selectForm: {
        name: '',
        suffix: '',
        type: ''
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false,
      enumList: []
    };
  },
  methods: {
    openDoc: function openDoc(row) {
      var fileUrl = this.uploadUrl + row.url;
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + fileUrl);
    },
    downFile: function downFile(row) {
      var fileUrl = this.uploadUrl + row.url;
      window.open(fileUrl);
    },
    getImage: function getImage(row) {
      var url = row.url;
      return this.uploadUrl + url;
    },
    getVideo: function getVideo(row) {
      return this.uploadUrl + row.abbreviationImg;
    },
    playVideo: function playVideo(row) {
      this.playTitle = row.name;
      this.dialogPlay = true;
      this.videoUrl = this.uploadUrl + row.url;
    },
    closeDialog: function closeDialog() {
      this.dialogPlay = false;
      this.videoUrl = '';
    },
    typeChace: function typeChace(res) {
      this.pageNo = 1;
      this.initTableData();
    },
    initEunmData: function initEunmData() {
      this.getEnumList('file_type');
    },
    getEnumList: function getEnumList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.enumList = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    checkType: function checkType(type) {
      for (var res in this.enumList) {
        var item = this.enumList[res];
        if (item.keys === type) {
          return item.values;
        }
      }
    },
    switchChange: function switchChange(value) {
      this.updateStats(value);
    },
    checkStatsType: function checkStatsType(data) {
      if (data.stats === 0) {
        return 'success';
      } else {
        return 'danger';
      }
    },
    checkStats: function checkStats(data) {
      if (data.stats === 0) {
        return '正常';
      } else {
        return '已注销';
      }
    },
    btnCheckStats: function btnCheckStats(data) {
      if (data.stats === 0) {
        return '注销';
      } else {
        return '恢复';
      }
    },
    updateStats: function updateStats(data) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                id: data.id,
                stats: data.stats
              };
              _context2.n = 1;
              return api.UPDATE_FILE(par);
            case 1:
              _this2.initTableData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    updateApi: function updateApi(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.UPDATE_FILE(row);
            case 1:
              _this3.$message.success('变更成功');
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    updateName: function updateName(row) {
      var _this4 = this;
      this.$confirm('变更名称, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.updateApi(row);
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消变更'
        });
      });
    },
    dalete: function dalete(index, data) {
      var _this5 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.daleteApi(index, data);
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                fileId: data.fileId
              };
              _context4.n = 1;
              return api.DELETE_FILE(par);
            case 1:
              _this6.initTableData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return api.DELETE_BATCH_FILE(par);
            case 1:
              _this7.$message.success('操作成功');
              _this7.initTableData();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this8 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this8.tableSelects.forEach(function (element) {
          par.push(element.fileId);
        });
        _this8.deleteBatchApi(par);
      }).catch(function () {
        _this8.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      if (this.selectForm.type === '') {
        this.$message({
          type: 'info',
          message: '请选择类型'
        });
        return;
      }
      this.$refs.edit.setTitle('新增');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.selectForm.name = '';
      this.selectForm.suffix = '';
      this.selectForm.type = '';
      this.tableData = [];
    },
    search: function search() {
      if (this.selectForm.type === '') {
        this.$message({
          type: 'info',
          message: '请选择类型'
        });
        return;
      }
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var par, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              par = {
                pageNo: _this9.pageNo,
                pageSize: _this9.pageSize,
                name: _this9.selectForm.name,
                suffix: _this9.selectForm.suffix,
                type: _this9.selectForm.type
              };
              _context6.n = 1;
              return api.GET_FILE_PAGE_LIST(par);
            case 1:
              res = _context6.v;
              _this9.tableData = res.body.datas;
              _this9.pageTotal = res.body.sumDataCount;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initEunmData();
  }
};